import { ExternalsValidator, } from '@feature-hub/core';
export class LoggingExternalsValidator extends ExternalsValidator {
    constructor(providedExternals, logger) {
        super(providedExternals);
        this.logger = logger;
    }
    validate(requiredExternals, consumerId) {
        try {
            super.validate(requiredExternals, consumerId);
        }
        catch (error) {
            this.logger.warn(error);
        }
    }
}
//# sourceMappingURL=logging-externals-validator.js.map